/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsorderexpired2Inputs */

const en_ticketsorderexpired2 = /** @type {(inputs: Ticketsorderexpired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expired`)
};

const de_ticketsorderexpired2 = /** @type {(inputs: Ticketsorderexpired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgelaufen`)
};

/**
* | output |
* | --- |
* | "Expired" |
*
* @param {Ticketsorderexpired2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsorderexpired2 = /** @type {((inputs?: Ticketsorderexpired2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsorderexpired2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsorderexpired2(inputs)
	return de_ticketsorderexpired2(inputs)
});
export { ticketsorderexpired2 as "ticketsOrderExpired" }